<template>
	<card class="reSearchCardService">
		<div class="card-user">
			<div class="left_part">				
				<div class="avatarBlk">
					<h4 class="title">ID услуги</h4>
					<p class="description">{{objService.id}}</p>
					<span><span v-if="objService.lead_id !=''" class="ml-0 el-tag el-tag--small el-tag el-tag--plain el-tag--primary">из лида</span></span>
					<div class="itemPhoto mr-2" v-if="objService.object_photo">
						<img :src="objService.object_photo" alt="preview" >
					</div>
					<!--
					 	:style="{'background-image':objService.object_photo? 'url('+objService.object_photo+')':''}"
					    background-size: cover;
					-->


				</div>					
				<div class="fioContactsBlk">
					<div class="fioBlk mb-3">
						<h4 class="title">Клиент</h4>
						<p class="description"><span class="font-weight-bold mr-1">ID: </span><span>{{objService.client_id}}</span></p>
						<p class="description"><span class="font-weight-bold mr-1">ФИО: </span><router-link :to="'/data/clients/id/'+objService.client_id+'?service='+objService.id" >{{objService.client_fio}}</router-link></p>
						<p class="description" v-if="objService.client_descr"><span class="font-weight-bold mr-1">Примечание: </span> {{objService.client_descr}}</p>
						<p class="description"><span class="font-weight-bold mr-1">Тел.: </span> {{objService.phone_list}}</p>
						<div v-if="masPotrebnosti.length>0" class="">
							<p class="description"><span class="font-weight-bold mr-1">Потребности: </span> {{masPotrebnosti.join(', ')}}</p>
						</div>
					</div>
					<div class="contactsBlk" v-show="!$GVO.isEmpty(objService.contacts)">
						<h4 class="title">Контакты</h4>
						<template v-for="(dopContact, dc_index) in objService.contacts">
							<p class="description" :key="dc_index" v-if="dopContact.contact_group!='social' && typeof dopContact !='undefined'">
								<span class="d-inline-block mr-2">{{strContactType(dopContact)}}</span> 
								<a :href="hrefContact(dopContact.contact_group,dopContact.contact_value)" class="d-inline-block mr-1" :class="[{'text-primary':dopContact.contact_group=='email'},{'text-success':dopContact.contact_group!='email'}]">
									<i v-if="dopContact.contact_group=='email'" class="d-inline-block tim-icons icon-email-85"></i>
									<i v-if="dopContact.contact_group=='phone'" class="d-inline-block tim-ic ic-phone" @click="Call(dopContact.contact_value,'CLIENT',objService.client_id)"></i>
									<i v-if="dopContact.contact_group=='web'" class="d-inline-block tim-icons icon-link-72"></i>
									<i v-if="dopContact.contact_group=='messanger'" class="d-inline-block tim-icons icon-send"></i>
									<span v-if="dopContact.contact_group=='phone'" @click="Call(dopContact.contact_value,'CLIENT',objService.client_id)">{{dopContact.contact_value}}</span>
									<span v-else>{{dopContact.contact_value}}</span>
								</a>
							</p>
						</template>
					</div>
				</div>
			</div>
			<div class="right_part">
				<div class="uslugaBlk col-md-7 col-sm-12 px-0">
					<h4 class="title ml-2">Оказываемая услуга</h4>
					<div class="service-col mb-3 ml-2">
							<p :class="[{'text-warning':objService.STATUS == 'На контроле'}, {'text-danger':objService.STATUS == 'В архиве'}, {'text-primary':objService.STATUS == 'В работе'}, {'text-success':objService.STATUS == 'Сделка закрыта'}]">
								<span class="text-warning mr-2" v-if="objService.STATUS == 'На контроле'">На контроле: </span>
								<span class="text-danger mr-2" v-if="objService.STATUS == 'В архиве'">Отказ: </span>
								<span class="text-primary mr-2" v-if="objService.STATUS == 'В работе'">В работе: </span>
								<span class="text-success mr-2" v-if="objService.STATUS == 'Сделка закрыта'">Сделка: </span>
								{{objService.BP_NAME}} {{objService.BP_EXT_NAME}} 
							</p> 
							<template v-if="objService.PARENT_SERVICES.length > 0">
								<p class="d-flex mb-3 pr-3" v-for="parentService in objService.PARENT_SERVICES" :key="parentService.id">Родительская услуга: <span class="mb-0 ml-2">{{parentService.BP_NAME}} {{parentService.BP_EXT_NAME}} (ID услуги: {{parentService.id}})</span></p>	
							</template>

							<div class="service-row" v-if="objService.agrm_number">
								<p class="d-inline-block"><b>Договор №: </b>{{ objService.agrm_number }}</p>
								<p class="d-inline-block mr-3 ml-1 ">(с {{ $GVO.convertDateTimeFromMysqlToDate(objService.agrm_date_begin) }} по {{ $GVO.convertDateTimeFromMysqlToDate(objService.agrm_date_end) }})</p>  
							</div>
							<div class="service-row">
								<p class="d-inline-block mr-3 ml-1 service-title marker">Этап</p>
								<p>{{objService.STAGE_NAME}}</p>
							</div>
							<div class="service-row" v-if="typeof objService.adsSourceName != 'undefined' && objService.adsSourceName != '' && objService.adsSourceName != null">
								<p class="d-inline-block mr-3 ml-1 service-title marker">Рекламный источник</p>
								<p>{{objService.adsSourceName}}</p>
							</div>
							<div class="service-row" v-if="typeof objService.lead_source != 'undefined' && objService.lead_source != '' && objService.lead_source != null">
								<p class="d-inline-block mr-3 ml-1 service-title marker">Источник лида</p>
								<p>{{objService.lead_source}}</p>
							</div>
							<div class="service-row">
								<p class="d-inline-block mr-3 ml-1 service-title marker">Ответственный</p>
								<p>{{objService.agent_name}}</p>
							</div>
					</div>
				</div>

				<div class="taskBlk col-md-5 col-sm-12 px-0">
					<h4 class="title">Задачи</h4>
					<template v-if="typeof objService.BP_TASKS !='undefied' && objService.BP_TASKS.length>0">
						<div v-for="task in objService.BP_TASKS" :key="task.id">
									<!--a href="#">{{task.BP_TASK_NAME}}</a-->
									<router-link :class="[{'text-danger':task.overdue == '1' && task.STATUS!='Готово'}]" :to="'/data/tasks/id/'+task.id">
										<i v-if="task.overdue == '1' && task.STATUS!='Готово'" class="tim-icons text-danger icon-alert-circle-exc"></i>
										{{task.BP_TASK_NAME}}  
									</router-link>
									<span v-if="task.READONLY =='1' && task.overdue != '1' && task.STATUS!='Готово' && task.editable!=0">{{$GVO.convertDateTimeFromMysql(task.STARTDATE)}}</span>
						</div>
					</template>
				</div>
			</div>
		</div>
		<div class="card-user mt-2">
			<div class="row mx-0">			
				<div class="d-flex mr-5 align-items-baseline">
					<h4 class="mb-0 mr-2">Создано</h4>
					<p class="description">{{$GVO.convertDateTimeFromMysql(objService.InsertTime)}}</p>
				</div>
				<div class="d-flex mr-5 align-items-baseline">
					<h4 class="mb-0 mr-2">Посл. изменение</h4>
					<p class="description">{{$GVO.convertDateTimeFromMysql(objService.UpdateTime)}}</p>
				</div>
				<div v-if="objService.STATUS != 'Сделка закрыта'" class="d-flex mr-5 align-items-baseline">
					<h4 class="mb-0 mr-2">Дней в работе</h4>
					<p class="description">{{daysInWork}}</p>
				</div>
				<div v-if="objService.dt_expire && objService.dt_expire>'0000-00-00 00:00:00'" class="d-flex mr-5 align-items-baseline">
					<h4 class="mb-0 mr-2">Осталось времени</h4>
					<ReBackTimer :time="objService.dt_expire"/>
				</div>
			</div>
		</div>
	</card>
</template>

<script>
	import moment from 'moment';
	import ReBackTimer from './ReBackTimer.vue';
import ReSearchTaskStaffVue from './ReSearchTaskStaff.vue'

	export default {
		name: 'ReSearchCardService',
		components: {
			ReBackTimer
		},
		props: {
			objService: Object,
		},
		data () {
			return {
				ver: 1,
				objPotrebnostiFields:{
					'all':['rooms','district_ids','metro_ids','fin_purchase'],
					'15':['rooms','district_ids','metro_ids','fin_purchase'],
				}
			}
		},
		computed: {
			masPotrebnosti: function(){
				let masRet = [];
				let masFields = [];
				if(Object.keys(this.objPotrebnostiFields).indexOf(this.objService.BP_ID) != -1){
					masFields = this.objPotrebnostiFields[this.objService.BP_ID];
				}else{
					masFields = this.objPotrebnostiFields['all'];
				}
				if(masFields.length>0){
					for (let i = 0; i < masFields.length; i++) {
						if(typeof this.objService[masFields[i]] != 'undefined' && this.objService[masFields[i]] != ''){
							if(this.getPotrebnostiNormValue(masFields[i],this.objService[masFields[i]]) != '')
								masRet.push(this.getPotrebnostiNormValue(masFields[i],this.objService[masFields[i]]));
						}
					}
				}
				return masRet;
			},
			daysInWork(){
				let daysInWorkTotal = this.objService.InsertTime.replace(' ', 'T') +'Z';			
				let d = new Date();
				let newDateFormated = d.getFullYear() + '-' + ('0'+(d.getMonth()+1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + 'T' + ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) + ':' + ('0' + d.getSeconds()).slice(-2) +'Z';
				//console.log(daysInWorkTotal);
				//console.log(newDateFormated);

				let t = Date.parse(newDateFormated) - Date.parse(daysInWorkTotal);
				let minutes = Math.floor((t / 1000 / 60) % 60);
				let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
				let days = Math.floor(t / (1000 * 60 * 60 * 24));
				return `${days} д ${hours} ч ${minutes} м`;
				
				//ниже оригинал
				/*
				let t = Date.parse(new Date()) -  Date.parse(this.objService.InsertTime);
				//let seconds = Math.floor((t / 1000) % 60);
				let minutes = Math.floor((t / 1000 / 60) % 60);
				let hours = Math.floor((t / (1000 * 60 * 60)) % 24);
				let days = Math.floor(t / (1000 * 60 * 60 * 24));
				return `${days} д ${hours} ч ${minutes} м`;
				//return moment(this.objService.InsertTime).fromNow();
				*/
			}, 
		},
		methods: {
			getPotrebnostiNormValue(valType,value){
				let masResult = [];
				switch (valType) {
					case 'rooms':
						masResult = this.getPotrebnostiCatNormValue(value.split(','),'CAT_ROOMS');
						break;
					case 'district_ids':
						masResult = this.getPotrebnostiCatNormValue(value.split(';'),'CAT_DIST','name_tr');
						break;
					case 'metro_ids':
						masResult = this.getPotrebnostiCatNormValue(value.split(';'),'CAT_METRO');
						break;
					case 'fin_purchase':
						if(parseFloat(value) > 0)
							masResult.push(this.$GVO.formatAmount(parseFloat(value)));
						break;
					default:
						break;
				}
				return masResult.join(', ');
			},
			getPotrebnostiCatNormValue(masData,cat_name,cat_key){
				let masResult = [];
				for (let i = 0; i < masData.length; i++) {
					if(masData[i] != ''){
						let v = this.$GVO.GetCatValName(cat_name,masData[i],cat_key);
						if(v != false){
							masResult.push(v);
						}else{
							masResult.push(masData[i]);
						}
					}						
				}
				return masResult;
			},
			getTasks(task_tree){
				let masTasks = this.$GVO.SafeParseJson(task_tree);
				//console.log(masTasks);
				if(this.$GVO.isEmpty(masTasks)){return[];}
				return masTasks[''];
			}
		}		
	}
</script>
<style scoped>
	.reSearchCardService {border: 1px solid #9e77f3;  box-shadow: 0px 3px 10px 0px rgba(123, 123, 123, 0.25)!important;}
	.reSearchCardService .card-user{
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	.reSearchCardService .card-user .author{margin-top: 0px;}
	.card-user .left_part, .card-user .right_part{
		width: 100%;
		display: flex;
		flex-flow: row nowrap;
	}
	.card-user .left_part{max-width:490px;}
	.card-user .right_part{justify-content: space-between;}
	.card-user .left_part > *, .card-user .right_part > *{display: inline-block; vertical-align: top; margin-right: 15px;}
	/*.card-user .right_part > *{width: calc(100% / 3); min-width: 180px;}*/

	.avatarBlk{width:100px;display: inline-flex !important; flex-direction: column;}
	.avatarBlk .avatar{
		object-fit: contain;
		background-color: white;
	}

	.fioContactsBlk{
		display: flex;
		width: 250px;
	}
	.reSearchCardService .description {word-break: break-word;}
	p.description{font-size: 1em;}
	p.description a > i{ margin-right: 5px;}

	.btn-icon .fab{
		position: absolute;
		font-size: 1em;
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-12px, -12px);
		transform: translate(-12px, -12px);
		line-height: 1.5626rem;
		width: 24px;
	}
	.service-col {display: flex; flex-direction: column;}
	.service-row {display: flex; flex-wrap: wrap;}
	.agent-name, .service-title {font-weight: bold;  padding-left: 8px;}
	/* .marker::before {
		content: "\20DD";
		color: #01B0E0;
		padding-right: 18px;
		font-size: 8px;
		font-weight: normal;
	} */

	.marker::before {
		content: "";
		display: inline-block;
		margin-right: 10px;
		border: 1px solid #01B0E0;
		width: 12px;
		height: 12px;
		border-radius: 50%;
		font-size: 12px;
		font-weight: normal;
	}
	.card-warning {box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.08)!important; border: 1px solid #ff8d72!important;}
	.card-danger {box-shadow: 0 1px 15px 0 rgba(123, 123, 123, 0.08)!important; border: 1px solid #f84e54!important;}
	.fioBlk a {font-size: 16px;}


	.itemPhoto {
		display: flex;
		width: 90px;
		height: 90px;
		position: relative;
		transition: 2s 0s;
	}
	.itemPhoto img{
		width: 100%;
		height: 100%;
		margin: 0 auto;
		object-fit: cover;
	}

	.card-body:hover .itemPhoto{
		transform:rotate(360deg);
		transition: 2s 10s;
	}


	@media (max-width: 860px){
		.reSearchCardService .card-user{
			display: block;
		}
		.card-user .right_part{display: block;}	
		.uslugaBlk, .stageBlk, .taskBlk {margin-top: 20px;}
		.card-user .author {text-align: start; display: block;}
		.card-user .title h4 {margin-bottom: 5px;}
		.card-user .left_part {max-width: 100%; display: flex;}		
		
	}
	@media (max-width: 600px){
		.card-user .right_part > *{display: block; width: 100%;}
		.card-user .left_part {flex-direction: column;}		
		/* .avatarBlk {flex-direction: row; align-items: center;} */
		.avatarBlk {flex-direction: column; }
		.title {margin-right: 10px; margin-bottom: 5px;}
		.fioBlk .title {display: none;}
	}
</style>
